module.exports = __webpack_public_path__ + "img/Lavish4.a971ea2e.jpg";